export enum FORMSTEPS {
    PERSONAL_INFO = 0,
    ACCESSES = 1,
    COACH = 2,
    SETTINGS = 3,
    ONBOARDING_CONTENT = 4,
    REVIEW = 5,
}
